import { GuidedTour } from "./guided-tour.service";

export const GuidedTourRegistry: Map<string, GuidedTour> = new Map();
export function registerGuidedTour(identifier: string, tour: GuidedTour) {
    GuidedTourRegistry.set(identifier, tour);
}
